import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import Header from "../Header/Header";
import TextInput from "../CommonFields/TextInput";
import Button from "../CommonFields/Button";
// import Avatar from '../../images/Avatar.png'
import BaseHome from "./BaseHome"
import { useNavigate } from 'react-router'
import { loginWithToken, getFreeAvatar, firstTimeProfileUpdate } from "../../api/auth.api";
import { useProfileDataContext } from "../ProfileContext/ProfileContext";
import { routesFrontend } from "../RouterFiles/routes";
import { toastSuccess, toastError } from "../../Utilities/toast";
import { termsNConditionPage } from "../../api/public.api";
import ListLoader from "../Common/ListLoader";
import { base_apis } from "../../config/url";
const imgURL = base_apis?.imageUrl


const CreateProfile = () => {
  const navigate = useNavigate();
  //PRE-REQUSITS
  const { profileData, setProfileData } = useProfileDataContext()
  const [searchParams] = useSearchParams()
  const [currentLang, setCurrentLang] = useState("en");
  const [error, setError] = useState('')
  const { t } = useTranslation();

  //USE STATE
  const [token, setToken] = useState(null);
  const [userDetails, setUsersDetails] = useState(null);
  const [freeAvatars, setFreeAvatars] = useState([]);
  const [userAvatars, setUserAvatars] = useState(null);
  const [gamerjiName, setGamerjiName] = useState(null);
  const [viToken, setViToken] = useState(null);
  const [userActiveAvatars, setUserActiveAvatars] = useState(0);
  //TRANSATION TEXT
  const translatedText = t("termsAndCondtions", {
    interpolation: { escapeValue: false },
  });

  //USE EFFECTS
  //TOKEN LOGIN FLOW:START
  useEffect(() => {
    let tempToken = searchParams.get('token') || localStorage.getItem('token') || null
    if (tempToken) {
      setToken(tempToken)
    } else {
      console.log("TOKEN: NOT FOUND")
    }
    // fetchfreeAvatar()
  }, [])
  useEffect(() => {
    if (token !== null) {
      setLoading(true);
      fetchUsersDetails()
    }
  }, [token])
  //TOKEN LOGIN FLOW:END

  useEffect(() => {
    const linkTag = document.getElementById("bootstrap_css");
    document.documentElement.setAttribute("lang", currentLang.toLowerCase());
    document.documentElement.dir =
      currentLang.toLowerCase() === "ar" ? "rtl" : "ltr";
    if (currentLang.toLowerCase() === "ar") {
      linkTag?.setAttribute(
        "href",
        `${process.env.REACT_APP_CLIENT_BASE_URL}assets/css/bootstrap.rtl.min.css`
      );
    }

    document.title = t("title");
  }, [currentLang]);

  const fetchUsersDetails = async () => {
    try {
      let data = {
        token: token
      };
      const res = await loginWithToken(data);
      if (res.success && res?.user) {
        localStorage.setItem('viToken', res?.token)
        setViToken(res?.token)
        localStorage.setItem('profileLite', JSON.stringify(res?.user))
        localStorage.setItem('countryId', JSON.stringify(res?.user?.address?.country))
        setUsersDetails(res?.user)
        setProfileData(res?.user)
      
        if (res?.user?.isAccountApproved &&
          res?.user?.isAccountApproved === true &&
          res?.user?.avatar !== null
        ) {

          // navigate(routesFrontend.home)
          window.location.href = "/home"
        } else if (res?.user?.avatar === null) {
          setLoading(false);
          await fetchfreeAvatar();
        } else if (res?.user?.avatar !== null) {
          setLoading(false);
          await fetchfreeAvatar();
          setUserActiveAvatars(res?.user?.avatar);
        }
      } else {
        toastError(res?.data?.errors[0]?.msg)
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };




  const fetchfreeAvatar = async () => {
    try {
      let data = {
        "pagination": {
          "pageNo": 1,
          "recordPerPage": 10,
          "sortBy": "createdAt",
          "sortDirection": "asc"
        }
      };
      const res = await getFreeAvatar(data);
      if (res?.data) {
        setFreeAvatars(res?.data)
        setUserActiveAvatars(res?.data?.[0]?._id)
      }
    } catch (error) {
    }
  };

  const onSubmitUpdateProfile = async () => {
    try {
      let tempAvatar = userActiveAvatars || null
      let tempGamerjiName = gamerjiName || null
      if (!tempAvatar) {
        setError(t('errors.error_select_avatar'))
        return
      }
      if (!tempGamerjiName) {
        setError(t('errors.error_username_please'))
        return
      } else if (tempGamerjiName.length < 3) {
        setError(t('errors.error_username_min_lenght'))
        return
      }
      else if (tempGamerjiName.length > 32) {
        setError(t('errors.error_username_max_lenght'))
        return
      }
      let data = {
        avatar: tempAvatar,
        gamerjiName: tempGamerjiName
      };
      const res = await firstTimeProfileUpdate(data, viToken);
      // alert(res)
      console.log(res)

      if (res?.data && res.success == true) {

        navigate(routesFrontend.home)
      } else {

      }
      toastError(t(res.data.errors[0].msg))
    } catch (error) {
      // console.log("error",error)
      // alert(error)
      //  console.log("error",error)
      toastError("Profile Update Error !!")
    }
  };

  const [terms, setTerms] = useState("");
  const [isLoading, setLoading] = useState(true);
  const [showVisible, setShowTerms] = useState(false);

  const onClickTerms = () => {
    setShowTerms(true)
    fetchTerms()
  }
  const fetchTerms = async () => {
    try {
      setLoading(true);
      const response = await termsNConditionPage();
      setLoading(false);
      if (response?.success && response?.data) {
        setTerms(response?.data?.description)
      }
    }
    catch (error) {
      setLoading(false);
    }
  };
  const ExitToApp = () => {
    // localStorage.clear();
    let value = JSON.stringify({ "tag": "back pressed" });
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(value);
    }
  }
  return (
    <BaseHome title={!showVisible ? t("esports") : t("moreMenu.term_of_use")} isWallet={false} onBackClick={() => {
      if (!showVisible) { ExitToApp() }
      else { setShowTerms(false) }
    }}>
      {(!showVisible) &&
        <>
          {!isLoading ? <>
            {userDetails &&
              <>
                <section className="welcome">

                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="66"
                      height="66"
                      viewBox="0 0 66 66"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M59.7515 11.4818V13.9032H59.2061V11.4818H58.3301V11.0107H60.6234V11.4818H59.7515ZM61.4487 11.9859V13.9032H60.9404V11.0107H61.5685L62.4445 13.147L63.3205 11.0107H63.9486V13.9032H63.4403V11.9859L62.6511 13.9032H62.2379L61.4487 11.9859Z"
                        fill="#FEFEFE"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M44.8164 43.5311H56.4324V11H44.8164V43.5311ZM29.4058 11L21.8861 41.3131L14.3662 11H2.75L10.8201 43.5311H32.952L41.022 11H29.4058Z"
                        fill="white"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M56.9473 53.6096C56.9473 57.0893 54.1164 59.9102 50.6241 59.9102C47.1318 59.9102 44.3008 57.0893 44.3008 53.6096C44.3008 50.1297 47.1318 47.3086 50.6241 47.3086C54.1164 47.3086 56.9473 50.1297 56.9473 53.6096Z"
                        fill="#FFC600"
                      />
                    </svg>
                  </div>
                  <div className="mt-4">
                    <h3 className="f-bold"> {t("hey")} </h3>
                  </div>
                  <div>
                    <p className="welcomeText">{t("welcomwToVI")}</p>


                  </div>
                </section>
                <section className="create-profile">
                  <div className="text-input">
                    <TextInput
                      placeholder={t("enterName")}
                      labelName={t("username")}
                      value={gamerjiName !== null ? gamerjiName : ""}
                      helperText={error}
                      inputLength="64"
                      onChange={(e) => {
                        let value = e.target.value
                        setGamerjiName(value)
                      }} />
                  </div>
                  <div className="home  py-2">
                    <p className="pb-0 mb-0 pt-4">{t('chooseAvatar')}</p>
                  </div>

                  {/* FREE AVATAR LIST BLOCK */}
                  <div className="avatar" key={userActiveAvatars}>
                    {freeAvatars?.length > 0 &&
                      freeAvatars?.map((e) => {
                        return (
                          <div className={`avatar-box ${userActiveAvatars === e._id ? "active" : ""}`} onClick={() => { setUserActiveAvatars(e._id) }}>
                            <div className="inner">
                              <div className="half-circle">
                              </div>
                              <div className="avatar-image" >
                                <img src={`${imgURL}${e?.img?.default}`} alt={`avatar-${e?.description}`} />
                                <p className="text-center mt-2">{e.name}</p>
                              </div>
                            </div>
                          </div>
                        )
                      })}
                  </div>
                  {/* FREE AVATAR LIST BLOCK */}
                  <div className="home py-4">
                    <p className="" onClick={() => { onClickTerms() }}>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: translatedText,
                        }}
                      />
                    </p>
                    {/* <p className="text-white f-12 w-100 text-wrap" ><span>Token::{token}</span></p> */}
                  </div>
                  <div className="my-4">
                    <Button text={t("submit")} onClick={onSubmitUpdateProfile} />
                  </div>
                </section>
              </>
            } </> : <> <div className='w-100 d-flex justify-content-center no-record-found-center'> <ListLoader /></div></>}
        </>
      }

      {
        showVisible &&
        (
          isLoading ?
            <div className='w-100 d-flex justify-content-center no-record-found-center'> <ListLoader /></div> :
            <div className="page-rules-list" dangerouslySetInnerHTML={{ __html: terms }} />

        )
      }

    </BaseHome>
  );
};

export default CreateProfile;
